import api from './axiosConfig';

// ─── View Models (responses from backend) ─────────────────────────────────────

export interface PromoCodePoolListItem {
  businessContentfulId: string;
  businessName: string | null;
  total: number;
  claimed: number;
  remaining: number;
}

export interface PromoCodeClaim {
  code: string;
  claimedAt: string;
  // Null when the claimant's account has since been erased (the code stays spent).
  email: string | null;
  name: string | null;
  externalId: string | null;
}

export interface PromoCodeClaimsResponse {
  pageNumber: number;
  pageSize: number;
  total: number;
  data: PromoCodeClaim[];
}

// ─── API calls ────────────────────────────────────────────────────────────────

export const getPromoCodePools = async (): Promise<PromoCodePoolListItem[]> => {
  const response = await api.get('/promo-codes/pools');
  return response.data;
};

export const getPromoCodeClaims = async (
  businessContentfulId: string,
  params: { search?: string; pageNumber: number; pageSize: number }
): Promise<PromoCodeClaimsResponse> => {
  const response = await api.get(
    `/promo-codes/${encodeURIComponent(businessContentfulId)}/claims`,
    { params }
  );
  return response.data;
};
